export default "__VITE_ASSET__DMpZ3EDr__"